<template>
  <WebTop />
  <div id="body-wrap">

  <div class="home-block-title" style="margin-top: 24px;">
    <Icon type="ios-book-outline" color="#2d8cf0" /> <b style="color: #2d8cf0">在线机器人维权</b>
  </div>

  <div class="question-detail-wrap">
    <div id="talk-wrap" v-if="talks.length>0">
      <ul class="talk-wrpa" v-for="item in talks" :key="item.id">
        <li class="ask">
          <div class="ask-content">{{ item.text }}</div>
          <div class="ask-pre">问</div>
          <div class="c"></div>
        </li>
        <li class="reply">
          <div class="reply-pre">答</div>
          <div class="reply-content">{{ item.reply }}</div>
          <div class="c"></div>
        </li>
      </ul>
    </div>
    <div id="talk-wrap" v-else>
      <Alert style="margin: 24px;">
        维权机器人欢迎您！
        <template #desc>欢迎您使用在线机器人维权，请您再下面的输入框输入内容，将自动为您回复答案。</template>
      </Alert>

      <Alert style="margin: 24px;" v-if="prefixKeys.length>0">
        <b>您可以直接点击如下问题：</b>
        <div style="padding: 6px 0;" v-for="key in prefixKeys" :key="key">
          <a @click="fillAndSubmit(key)">{{key}}</a>
        </div>
      </Alert>

    </div>
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="0">
        <FormItem label="" prop="text">
          <Input v-model="formValidate.text" placeholder="输入咨询内容"></Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formValidate')">发送</Button>
        </FormItem>
      </Form>
  </div>
</div>

</template>
<script>
import WebTop from '../../components/WebTop.vue'
import global from '../../utils/global'
import axios from 'axios'
export default {
  components: {
    WebTop
  },
  data () {
    return {
      user: null,

      talks:[],

      //预设问题
      prefixKeys:[],

      formValidate: {
        text: ''
      },
      ruleValidate: {
        text: [
            { required: true, message: '内容不能为空', trigger: 'blur' },
            { type: 'string', min: 2, message: '内容至少2个字', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.initUser()
    this.listPrefix()
  },
  methods: {
    //初始化用户信息
    initUser() {
      let userStr = localStorage.getItem("user")
      if(userStr!=null) {
        this.user = JSON.parse(userStr)
      }
    },

    //获取预设问题
    listPrefix() {
      let vm = this
      //let id = this.$route.query.id
      axios({
        method: 'post',
        url: global.restUrl + '/api/web/robot/v1.0/prefix',
        //data: vm.formValidate,
        headers: {
          token: vm.user.token
        }
      }).then(function (response) {
        let success = response.data.success
        if(success) {
          // vm.talks.push(response.data.data);
          // vm.formValidate.text = ""
          vm.prefixKeys = response.data.data.list
          //console.log(response.data.data.list)
        }
      });
    },

    //填空并提交
    fillAndSubmit(key) {
      this.formValidate.text=key
      this.handleSubmit('formValidate')
    },

    //提交
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
          if (valid) {
            let vm = this
            //let id = this.$route.query.id
            axios({
              method: 'post',
              url: global.restUrl + '/api/web/robot/v1.0/talking',
              data: vm.formValidate,
              headers: {
                token: vm.user.token
              }
            }).then(function (response) {
              let success = response.data.success
              if(success) {
                vm.talks.push(response.data.data);
                vm.formValidate.text = ""
                //console.log(vm.talks)
              }
            });
          } else {
              this.$Message.error('表单校验失败');
          }
      })
    },
  }
}
</script>
